import { Card, CardContent, CardHeader, Divider, Stack, Typography } from '@mui/material';
import ReactPlayer from 'react-player';
import ErrorMessage from '../errorMessage';
import { useElementSize } from '@custom-react-hooks/use-element-size';

type Props = {
  videoDataUrl: string;
  maxHeight: number;
  showLabel?: boolean;
  label?: string;
  error?: string;
};

const VideoViewer = ({ videoDataUrl, showLabel = true, label, error, maxHeight }: Props) => {
  const [headerRef, headerSize] = useElementSize();

  return (
    <Card variant="outlined" sx={{ border: label || error ? 1 : 0, borderColor: 'divider' }}>
      {showLabel && (label || error) && (
        <CardHeader
          title={
            <Stack direction="row" spacing={2} justifyContent="space-between" alignItems={'center'}>
              <Typography sx={{ textOverflow: 'ellipsis' }}>{label}</Typography>
            </Stack>
          }
          subheader={error && <ErrorMessage error={error} />}
          sx={{ p: 1 }}
          ref={headerRef}
          disableTypography
        />
      )}
      {showLabel && (label || error) && <Divider />}
      <CardContent sx={{ overflowY: 'auto', height: `calc(100% - ${headerSize.height + 5}px)`, p: 0 }}>
        <ReactPlayer src={videoDataUrl} controls={true} />
      </CardContent>
    </Card>
  );
};

export default VideoViewer;
